import React from "react";
import "./route-leaders.scss";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
const RouteLeaders = (props: ReferenciaContenido) => {
  const leaders = props;
  const nombreCategoria = props.nombreCategoria;
  return (
    <div className="m-leaders">
      <div className="m-leaders-container">
        <div className="m-leaders-container__title">
          <p>{leaders.tituloGeneral}</p>
          <span>
            {leaders.descripcion &&
              JSON.parse(leaders.descripcion?.raw)?.content[0]?.content[0]
                ?.value}
          </span>
        </div>
        <div className="m-leaders-container__content">
          {leaders.referenciaPlantillaContenido &&
            leaders.referenciaPlantillaContenido.map((value, index) => {
              return (
                <div className="m-leaders-container__content-card" key={index}>
                  <img
                    src={
                      value.imagenPrincipal[0]?.gatsbyImageData === null
                        ? value.imagenPrincipal[0]?.file.url
                        : value.imagenPrincipal[0]?.gatsbyImageData
                    }
                    alt={value.imagenPrincipal[0].title}
                  />
                  <p>{value.tituloBanner}</p>
                  <ul>
                    {value.descripcion &&
                    JSON.parse(value.descripcion.raw).content[0]?.content[0]
                      ?.value !== null ? (
                      <span className="m-leaders-container__content-card-desc">
                        {value.descripcion &&
                          JSON.parse(value.descripcion.raw).content[0]
                            .content[0].value}
                      </span>
                    ) : (
                      ""
                    )}
                    {value.descripcion &&
                      JSON.parse(value.descripcion.raw).content.map((val) => {
                        return val.nodeType === "unordered-list"
                          ? val.content.map((el, i) => {
                              return (
                                <li key={i}>
                                  <span>
                                    {el.content[0]?.content[0]?.value}
                                  </span>
                                </li>
                              );
                            })
                          : "";
                      })}
                  </ul>
                </div>
              );
            })}
        </div>
        <div className="m-leaders-container__footer">
          <Button
            type="link"
            text={leaders.tituloBoton}
            classname={`primary`}
            gtmMark={`gtm${nombreCategoria}${normalizeTwoWords(
              leaders.tituloBoton
            )}`}
            isDisabled={false}
            href={leaders.redireccionBoton}
          />
        </div>
      </div>
    </div>
  );
};

export default RouteLeaders;
